export const WENT_WRONG_MESSAGE = "Something went wrong.";
